import {Chip} from "@mui/material";

export function DisconnectedStatus() {
    return <Chip sx={{
        fontSize: 'xsmall'
    }} label="Disconnected" color="error" />
}